module.exports = __webpack_public_path__ + "img/skull_3_bj.50c032b8.png";